import { BooleanField } from '@src/permitField/PermitFields';
import * as yup from 'yup';

export const FilePathFieldName = 'filePath' as const;
export const SendToClientFieldName = 'sendToClient' as const;

export class ConditionSheetsField {
  public static fieldName = 'conditionsSheets' as const;
  public static validator = yup.array().of(
    yup.object().shape({
      id: yup.string().required(),
      [FilePathFieldName]: yup.string().required(),
      [SendToClientFieldName]: yup.boolean().required() as yup.BooleanSchema<
        NonNullable<boolean>
      >,
    }),
  );
}

export class ShowInstructionsToClientField extends BooleanField {
  public static fieldName = 'showInstructionsToClient' as const;
}
